import { Component, OnInit, Input, Inject, EventEmitter, Output } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { PropertyService } from '../../../../property';
import { AlertService } from '../../../../../_services';
import { ApiResponse } from '../../../../../_models';
import { Feature } from '@app/_components/property/feature';
import { FeatureService } from '@app/_components/property/feature';
import { BedService } from '../../bed.service';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
    selector: 'app-bed-form',
    templateUrl: './bed-form.component.html',
    styleUrls: ['./bed-form.component.css'],
    standalone: false
})
export class BedFormComponent implements OnInit
{



	constructor(private router: Router,
		private activatedRoute: ActivatedRoute,
		private bedService: BedService,
		private featureService: FeatureService,
		private alertService: AlertService,
		private location: Location,
		private formBuilder: UntypedFormBuilder,
		private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) data)
	{
		this.bedroomId = data.bedroomId;
	}



	@Input() bed: any;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	apiResponse: ApiResponse;
	bedroomId: number;
	bedId: number;


	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAction: String;
	formLabels = [];
	formReadOnly = false;
	formAlert: String;
	formTitle: String;

	// values are the ProductVOIds
	bedTypes = [
		{ value: '40', name: 'King' },
		{ value: '47', name: '(1)One King or (2)Two Twins ' }, // this works
		{ value: '42', name: 'Queen' },
		{ value: '43', name: 'Double' },
		{ value: '44', name: 'Twin' },
		{ value: '306', name: 'Twin XL' },
		{ value: '45', name: 'Crib' },
		{ value: '34', name: 'Pak N Play' },
		{ value: '48', name: 'Bunk' },
		{ value: '329', name: 'Queen over Queen Bunk Bed' },
		{ value: '38', name: 'Couchbed' },
		{ value: '26', name: 'Rollaway' },
		{ value: '52', name: 'Inflatable' },
		{ value: '54', name: 'Murphy' },
		

	];



	validationMessages = {
		bedType: [],
		sleepsMax: [],
		description: [],
	};

	ngOnInit()
	{
		this.formBuild();
		if (this.bed)
		{
			this.form1.patchValue(this.bed);
			this.bedId = this.bed.bedId;
		}
	}


	formAdd()
	{
		try
		{
			// stop here if form is invalid
			if (this.form1.invalid)
			{
				return;
			}

			this.formLoading = true;
			this.bedService.add(this.form1.value)
				.subscribe(
					res =>
					{
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
						this.bed = res.data.bed;
						this.doAdd.emit(this.bed);

					},
					err =>
					{
						console.log('bed-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}


	formUpdate()
	{
		console.log('bed: ' + JSON.stringify(this.form1.value));
		try
		{
			// stop here if form is invalid
			if (this.form1.invalid)
			{
				return;
			}
			this.formLoading = true;

			this.bedService.update(this.form1.value)
				.subscribe(
					res =>
					{
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
						this.bed = res.data.bed;
						this.doUpdate.emit(this.bed);
					},
					err =>
					{
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error)
		{
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete()
	{
		try
		{
			// stop here if form is invalid
			if (this.form1.invalid)
			{
				return;
			}

			this.formLoading = true;

			this.bedService.delete(this.bed.bedId)
				.subscribe(
					res =>
					{
						console.log('bed-delete SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
						this.doDelete.emit(this.bed);
					},
					err =>
					{
						console.log('bed-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}

	formBuild()
	{
		/**
				   *
				   *
				   *
				   * FORM
				   *
				   */

		this.form1 = this.formBuilder.group({
			bedId: [this.bedId],
			bedroomId: [this.bedroomId],
			bedType: ['', Validators.required],
			sleepsMax: ['', Validators.required],
			description: [],
		});
	}
}
